var _rect, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobNewSavingScheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.0586,
    y: 25.7061,
    width: 39.1176,
    height: 44.7059,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2859_3539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 85,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4994 87.0832C69.3612 87.0832 87.0827 69.3617 87.0827 47.4998C87.0827 25.638 69.3612 7.9165 47.4994 7.9165C25.6375 7.9165 7.91602 25.638 7.91602 47.4998C7.91602 69.3617 25.6375 87.0832 47.4994 87.0832Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4993 31.6665V63.3332V31.6665ZM31.666 47.4998H63.3327H31.666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4993 31.6665V63.3332M31.666 47.4998H63.3327",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2859_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H95V95H0V0Z",
    fill: "#5A189A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobNewSavingScheme);
export default __webpack_public_path__ + "static/media/mob-new-saving-scheme.c4f2a045d3fb90d31dcc91fd4033ae04.svg";
export { ForwardRef as ReactComponent };